<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <v-card-title>Временные абоненты жилого комплекса</v-card-title>
      <div>
        <BaseTextField
          v-model="telephoneSearch"
          type-input="string"
          :is-button="false"
          label="Номер телефона"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="dialogNew = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создание временного абонента</span>
      </v-tooltip>
      <v-dialog v-model="dialogNew" max-width="700" content-class="dialog-border-radius">
        <create-temporary-abonent
          :active.sync="dialogNew"
          :doorphones="filteredDoorphones"
          :is-res-complex="true"
          icon="mdi-account-clock-outline"
          message="Новый абонент (временный)"
          @save="createTemporaryAbonent"
          @close="dialogNew = false"
        />
      </v-dialog>
      <v-dialog :value="!!currentEditItem" max-width="700" content-class="dialog-border-radius" @input="closeEditDialog">
        <create-temporary-abonent
          v-if="currentEditItem"
          :active.sync="editDialogActive"
          :edit-item="currentEditItem"
          :doorphones="filteredDoorphones"
          :is-res-complex="true"
          icon="mdi-account-clock-outline"
          message="Редактирование временного абонента"
          @update="updateTemporaryAbonentHandler"
          @close="closeEditDialog"
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateListAbonents"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
    >
      <template v-slot:item.telephone="{ item }">
        <div v-if="item.telephone">
          <div>
            <v-btn
              large
              outlined
              prepe
              color="aliceblue"
              style="height: 20px"
              class="routerLink"
              @contextmenu.prevent="copyToClipboard(item.telephone)"
            >
              <li>{{ formatPhoneNumber(item.telephone) }}</li>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:item.guest="{ item }">
        <div v-if="item.date_begin && item.date_end">
          {{ ruDateFormat(item.date_begin, true) }} - {{ ruDateFormat(item.date_end, true) }}
        </div>
      </template>
      <template v-slot:item.address="{ item }">
        <div v-if="item.address">
          {{ item.address }}, Кв {{ item.apartment }}
        </div>
      </template>
      <template v-slot:item.created_at="{ item }">
          {{ ruDateFormat(item.created_at) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <template v-if="$checkPermission('update_car_number_barrier')">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  v-bind="attrs"
                  v-on="on"
                  tile
                  small
                  class="btn__icon ml-4 mr-1"
                  width="18"
                  height="18"
                  @click.stop="openEditDialog(item)"
                >
                  <v-icon size="large">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  v-bind="attrs"
                  v-on="on"
                  tile
                  small
                  class="btn__icon ml-4 mr-1"
                  width="18"
                  height="18"
                  @click.stop="$set(dialogWarning, item.id, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
            <v-dialog v-model="dialogWarning[item.id]" max-width="420" content-class="dialog-border-radius">
              <baseDeleteModal
                :active.sync="dialogWarning[item.id]"
                @close="$set(dialogWarning, item.id, false)"
                @submit="deleteTemAbonents(item.id, item.car_number)"
                messageTitle="Удалить «временного» абонента?"
                messageText="Подтверждая, вы удалите «временного» абонента.
                Так же автомобильный номер будет удален из базы номеров всех шлагбаумов которые привязанные к ЖК."
              />
            </v-dialog>
          </template>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="resultDialog" max-width="600px" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Результат <span style="color: #388E3C; padding-left: 5px; padding-right: 5px">{{ action }}</span> шлагбаумов
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(result, index) in results" :key="index">
              <v-list-item-content>
                <v-list-item-title>id: {{ result.id }}, адрес: {{ result.address }}</v-list-item-title>
                <v-list-item-subtitle :class="result.success ? 'text-success' : 'text-error'">
                  {{ result.success ? 'Успешно' : 'Ошибка, возможно устройство не в сети.' }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseTextField from '../../BaseTextField';
import baseDeleteModal from '../../BaseDeleteModal';
import CreateTemporaryAbonent from '@/components/accounts/CreateTemporaryAbonent';
import formatPhoneNumber from '../../../mixins/formatPhoneNumber';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'ListTemporaryAbonentsResComplex',
  mixins: [formatPhoneNumber, ruDateFormatMixin],
  props: {
    barrier: {
      type: Object,
    },
  },
  components: { CreateTemporaryAbonent, BaseTextField, baseDeleteModal },
  data () {
    return {
      isCreated: true,
      lastCopiedText: null,
      filters: {},
      filterAbonents: {},
      responseTemporaryAbonents: [],
      telephoneSearch: '',
      carSearch: '',
      startDate: '',
      action: '',
      endDate: '',
      results: [],
      resultDialog: false,
      importFile: null,
      dialogWarning: {},
      dialogNew: false,
      dialogImport: false,
      dialogEdit: {},
      currentEditItem: null,
      editDialogActive: false,
      resResidentComplex: [],
      totalAccounts: 0,
      headersTable: [
        { text: 'id', value: 'id', sortable: false, align: 'center' },
        { text: 'Имя', value: 'name', sortable: false, align: 'center' },
        { text: 'телефон', value: 'telephone', sortable: false, align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Адрес', value: 'address', sortable: false, align: 'center' },
        { text: 'Промежуток действия номера', value: 'guest', sortable: false, align: 'center', width: '20%' },
        { text: 'Комментарий', value: 'comment', sortable: false, align: 'center' },
        { text: 'Дата и время создания', value: 'created_at', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, align: 'center', width: '5%' },
      ],
    };
  },
  created () {
    this.getResidentComplex();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.telephoneSearch) {
        return this.responseTemporaryAbonents.filter(item => {
          return item.telephone !== null &&
            String(item.telephone).toLowerCase().includes(this.telephoneSearch.toLowerCase());
        });
      } else {
        return this.responseTemporaryAbonents;
      }
    },
    filteredDoorphones () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'M');
      }
      return {};
    },
  },
  methods: {
    ...mapActions({
      updateCarNumber: 'Barriers/updateCarNumber',
      loadTemporaryAbonents: 'TemporaryAbonent/loadTemporaryAbonents',
      updateTemporaryAbonent: 'TemporaryAbonent/updateTemporaryAbonent',
      newTemporaryAbonent: 'TemporaryAbonent/newTemporaryAbonent',
      deleteTemporaryAbonent: 'TemporaryAbonent/deleteTemporaryAbonent',
      viewComplex: 'ResidentComplex/viewComplex',
    }),
    async copyToClipboard (telephone) {
      if (this.lastCopiedText === telephone) {
        return;
      }
      try {
        await navigator.clipboard.writeText(telephone);
        this.lastCopiedText = telephone;
        this.$flash_success('Телефон скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать номер телефона');
      }
    },
    async updateListAbonents () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    createTemporaryAbonent (actionShould, carNumber, notification, telephone, nameAbonent, comment, date, address, apartment) {
      this.action = 'Добавление гос номера';
      this.updateTableNumber(actionShould, carNumber, notification, date);

      const barrierIds = this.resResidentComplex.barriers
        .filter(barrier => barrier.device_id)
        .map(barrier => barrier.id);

      const dataAbonent = {
        telephone,
        barrier_ids: barrierIds,
        ...(nameAbonent && { name: nameAbonent }),
        ...(comment && { comment }),
        ...(address && { address }),
        ...(apartment && { apartment }),
        ...(carNumber && { car_number: carNumber }),
        ...(date.length && { date_begin: date[0], date_end: date[1] }),
      };

      this.newTemporaryAbonent(dataAbonent)
        .then(() => {
          this.$flash_success('Аккаунт успешно создан');
        })
        .catch(console.error);
    },
    getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then(async (res) => {
          this.resResidentComplex = res;
          await this.getData();
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
    async updateTableNumber (actionShould, carNumber, notification, date) {
      this.results = [];
      for (const barrier of this.resResidentComplex.barriers) {
        if (!barrier.device_id) {
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: false,
            error: 'Устройство старого образца.',
          });
          continue;
        }
        const barrierId = barrier.id;
        try {
          const dataCar = {
            action_should: actionShould,
            car_number: carNumber,
            notify: notification ? 'on' : 'off',
          };
          if (date.length) {
            dataCar.start_date = date[0];
            dataCar.end_date = date[1];
          }
          await this.updateCarNumber({
            id: barrierId,
            data: dataCar,
          });

          this.results.push({ id: barrierId, address: barrier.address, success: true });
        } catch (err) {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          }
          this.results.push({ id: barrierId, address: barrier.address, success: false });
        }
      }
      await this.getData();
      this.resultDialog = true;
    },
    openEditDialog (item) {
      this.currentEditItem = item;
      this.editDialogActive = true;
    },
    closeEditDialog () {
      this.currentEditItem = null;
      this.editDialogActive = false;
    },
    async updateTemporaryAbonentHandler (id, actionShould, carNumber, notification, telephone, nameAbonent, comment, date, address, apartment) {
      const barrierIds = this.resResidentComplex.barriers
        .filter(barrier => barrier.device_id)
        .map(barrier => barrier.id);

      const dataAbonent = {
        telephone,
        barrier_ids: barrierIds,
        ...(nameAbonent && { name: nameAbonent }),
        comment: comment || '',
        ...(address && { address }),
        ...(apartment && { apartment }),
        ...(carNumber && { car_number: carNumber }),
      };

      if (date.length) {
        dataAbonent.date_begin = date[0];
        dataAbonent.date_end = date[1];
      } else {
        dataAbonent.date_begin = null;
        dataAbonent.date_end = null;
      }

      try {
        await this.updateTemporaryAbonent({
          id: id,
          data: dataAbonent,
        });
        this.$flash_success('Абонент успешно обновлен');
        this.closeEditDialog();
        await this.getData();
      } catch (err) {
        console.error(err);
        this.$flash_warning('Ошибка при обновлении абонента');
      }
    },
    deleteTemAbonents (id, carNumber) {
      this.deleteTemporaryAbonent({
        id: id,
      })
        .then(async () => {
          this.$flash_success('Абонент успешно удален');
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при удалении абонента');
        });
      this.action = 'Удаление гос номера';
      const date = [];
      this.updateTableNumber('remove', carNumber, false, date);
    },
    async getData () {
      const barrierIds = (this.resResidentComplex.barriers || [])
        .map(barrier => barrier.id)
        .filter(id => id != null && id !== '');

      if (!barrierIds.length) {
        this.responseTemporaryAbonents = [];
        return;
      }

      this.filterAbonents.barriers = barrierIds.join(',');
      return this.loadTemporaryAbonents({
        filters: this.filterAbonents,
      })
        .then((data) => {
          this.responseTemporaryAbonents = data;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке временных абонентов');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: #000000;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
</style>
